<template>
  <span
    class="tw-rounded-full tw-ml-2 tw-bg-ublue-100 tw-text-ublue-700 tw-text-xs tw-leading-4.5 tw-inline-block tw-text-center tw-min-w-5 tw-p-0.5">
    {{ counter > 99 ? "9+" : counter}}
  </span>
</template>

<script>
export default {
  props: ["counter"],
};
</script>
